import { render, staticRenderFns } from "./Pridelovalec.vue?vue&type=template&id=ffab339e&"
import script from "./Pridelovalec.vue?vue&type=script&lang=js&"
export * from "./Pridelovalec.vue?vue&type=script&lang=js&"
import style0 from "./Pridelovalec.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports